import React, { useState, useEffect, use } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Sidebar from '../../components/ui/Sidebar';
import MobileNavigation from '../../components/ui/MobileNavigation';
import Breadcrumb from '../../components/ui/Breadcrumb';
import MetricsCard from './components/MetricsCard';
import VendorTable from './components/VendorTable';
import QuickActions from './components/QuickActions';
import ActivityFeed from './components/ActivityFeed';
import AddVendorModal from './components/AddVendorModal';
import UseVendorHook from 'hooks/UseVendorHook';
import { useSelector } from 'react-redux';
import UseEmployeeHook from 'hooks/UseEmployeeHook';
import UseSale from 'hooks/UseSale';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [addVendorModalOpen, setAddVendorModalOpen] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [activities, setActivities] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null); // store vendor being edited
  const [metrics, setMetrics] = useState({

    totalVendors: 0,
    activeEmployees: 0,
    monthlyTransactions: 0,
    totalRevenue: 0
  });

  const { getAllVendors ,editVendor} = UseVendorHook();
  const {getAlluserByAdmin} = UseEmployeeHook();
  const {getAllSaleByAdmin,getAllCustomerByVendor} = UseSale();
   let { vendor } = useSelector((state) => state.vendor);
  let { employee } = useSelector((state) => state.employee);
  let { sale, totalSale } = useSelector((state) => state.sale);
  // console.log(employee);

  // Mock data
  const mockVendors = [
    {
      id: 1,
      name: "TechCorp Solutions",
      email: "contact@techcorp.com",
      phone: "+1 (555) 123-4567",
      address: "123 Tech Street, Silicon Valley, CA",
      category: "technology",
      status: "active",
      employeeCount: 25,
      lastActivity: "2025-01-29T10:30:00Z",
      createdAt: "2024-12-15T09:00:00Z"
    },
    {
      id: 2,
      name: "Global Retail Inc",
      email: "info@globalretail.com",
      phone: "+1 (555) 234-5678",
      address: "456 Commerce Ave, New York, NY",
      category: "retail",
      status: "active",
      employeeCount: 18,
      lastActivity: "2025-01-28T14:15:00Z",
      createdAt: "2024-11-20T11:30:00Z"
    },
    {
      id: 3,
      name: "Manufacturing Pro",
      email: "admin@mfgpro.com",
      phone: "+1 (555) 345-6789",
      address: "789 Industrial Blvd, Detroit, MI",
      category: "manufacturing",
      status: "pending",
      employeeCount: 12,
      lastActivity: "2025-01-27T16:45:00Z",
      createdAt: "2025-01-10T08:15:00Z"
    },
    {
      id: 4,
      name: "Service Excellence",
      email: "hello@serviceexcel.com",
      phone: "+1 (555) 456-7890",
      address: "321 Service Road, Austin, TX",
      category: "services",
      status: "active",
      employeeCount: 8,
      lastActivity: "2025-01-26T12:20:00Z",
      createdAt: "2024-10-05T13:45:00Z"
    },
    {
      id: 5,
      name: "HealthTech Innovations",
      email: "support@healthtech.com",
      phone: "+1 (555) 567-8901",
      address: "654 Medical Center Dr, Boston, MA",
      category: "healthcare",
      status: "inactive",
      employeeCount: 15,
      lastActivity: "2025-01-20T09:10:00Z",
      createdAt: "2024-09-12T10:20:00Z"
    }
  ];

  const mockActivities = [
    {
      id: 1,
      type: "vendor_created",
      description: "New vendor account created",
      user: "John Admin",
      details: "TechCorp Solutions added to system",
      timestamp: "2025-01-30T15:30:00Z"
    },
    {
      id: 2,
      type: "employee_added",
      description: "Employee added to vendor account",
      user: "Sarah Manager",
      details: "New employee added to Global Retail Inc",
      timestamp: "2025-01-30T14:15:00Z"
    },
    {
      id: 3,
      type: "vendor_updated",
      description: "Vendor information updated",
      user: "Mike Admin",
      details: "Manufacturing Pro profile updated",
      timestamp: "2025-01-30T13:45:00Z"
    },
    {
      id: 4,
      type: "product_created",
      description: "New product added",
      user: "Lisa Vendor",
      details: "Premium Service Package created",
      timestamp: "2025-01-30T12:20:00Z"
    },
    {
      id: 5,
      type: "login",
      description: "Admin user logged in",
      user: "John Admin",
      details: "Successful login from IP 192.168.1.100",
      timestamp: "2025-01-30T11:10:00Z"
    },
    {
      id: 6,
      type: "vendor_deactivated",
      description: "Vendor account deactivated",
      user: "John Admin",
      details: "HealthTech Innovations temporarily suspended",
      timestamp: "2025-01-30T10:05:00Z"
    }
  ];

  useEffect(() => {
    const userData = localStorage.getItem('user');
    const token = sessionStorage.getItem('token');
    
    if (!userData || !token) {
      navigate('/whats-app-authentication');
      return;
    }

    const parsedUser = JSON.parse(userData);
    if (parsedUser.role !== 'admin') {
      navigate('whats-app-authentication');
      return;
    }
    getAlluserByAdmin();
    getAllSaleByAdmin()
    getAllVendors();
    // getAllCustomerByVendor();
    setUser(parsedUser);
    setVendors(vendor);
    setActivities(mockActivities);

    const activeVendors = vendors?.filter(v => v.active === true).length;
    const totalEmployees = vendor?.reduce((sum, v) => sum + v.employeeCount, 0);

    setMetrics({
      totalVendors: vendor?.length,
      activeEmployees: employee?.length,
      monthlyTransactions: sale?.length,
      totalRevenue: totalSale
    });
  }, [navigate]);
  useEffect(() => {
  setVendors(vendor);
}, [vendor]);
  // console.log(vendors);

  const handleSidebarToggle = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const handleMobileNavToggle = () => {
    setMobileNavOpen(!mobileNavOpen);
  };
  useEffect(() => { }, [vendors]);

  const handleAddVendor = (newVendor) => {
    if (selectedVendor) {
      // Update existing vendor
      setVendors(prev =>
        prev.map(v => (v.id === selectedVendor.id ? { ...v, ...newVendor } : v))
      );
      setSelectedVendor(null);
    } else {
      // Add new vendor
      setVendors(prev => [newVendor, ...prev]);

      const newActivity = {
        id: Date.now(),
        type: "vendor_created",
        description: "New vendor account created",
        user: user?.name || "Admin",
        details: `${newVendor.name} added to system`,
        timestamp: new Date().toISOString()
      };
      setActivities(prev => [newActivity, ...prev]);
      setMetrics(prev => ({
        ...prev,
        totalVendors: prev.totalVendors + 1
      }));
    }
  };

  const handleEditVendor = (vendor) => {
    setSelectedVendor(vendor);
    setAddVendorModalOpen(true);
  };

  const handleViewVendor = (vendor) => {

    // console.log('View vendor:', vendor);
  };

  const handleDeactivateVendor = async(vs,a) => {
    // console.log('Deactivate vendor:', vs);
    if(a=="delete"){
      let val = {
        ...vs,
        active: false
      }
      
      await editVendor(val);
    }else if(a=="active"){
      let val = {
        ...vs,
        active: true
      }
      // console.log(val)
      
      await editVendor(val);
    }
  
  getAllVendors();
  };

  if (!user) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <Header
        user={user}
        onSidebarToggle={handleMobileNavToggle}
        sidebarCollapsed={sidebarCollapsed}
      />

      <Sidebar
        user={user}
        collapsed={sidebarCollapsed}
        onToggle={handleSidebarToggle}
      />

      <MobileNavigation
        user={user}
        isOpen={mobileNavOpen}
        onClose={() => setMobileNavOpen(false)}
      />

      <main className={`pt-16 transition-all duration-200 ${sidebarCollapsed ? 'lg:pl-16' : 'lg:pl-60'}`}>
        <div className="p-6">
          <Breadcrumb user={user} />

          <div className="mb-8">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
              <div>
                <h1 className="text-2xl font-bold text-foreground">Admin Dashboard</h1>
                <p className="text-muted-foreground">
                  Welcome back, {user.name}. Here's what's happening with your vendors today.
                </p>
              </div>

              <div className="flex items-center space-x-3">
                <button
                  onClick={() => {
                    setSelectedVendor(null);
                    setAddVendorModalOpen(true);
                  }}
                  className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 micro-animation flex items-center space-x-2"
                >
                  <span className="text-sm font-medium">Add New Vendor</span>
                </button>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mb-8">
            <MetricsCard title="Total Vendors" value={metrics.totalVendors} change="+12%" changeType="increase" icon="Building2" color="primary" />
            <MetricsCard title="Active Employees" value={metrics.activeEmployees} change="+8%" changeType="increase" icon="Users" color="success" />
            <MetricsCard title="Monthly Transactions" value={metrics.monthlyTransactions.toLocaleString()} change="+23%" changeType="increase" icon="CreditCard" color="accent" />
            <MetricsCard title="Total Revenue" value={`$${metrics.totalRevenue.toLocaleString()}`} change="+15%" changeType="increase" icon="DollarSign" color="warning" />
          </div>

          <div className="grid grid-cols-1 xl:grid-cols-12 gap-6">
            <div className="xl:col-span-8">
              <VendorTable
                vendors={vendors}
                onEditVendor={handleEditVendor}
                onViewVendor={handleViewVendor}
                onDeactivateVendor={handleDeactivateVendor}
              />
            </div>

            <div className="xl:col-span-4 space-y-6">
              <QuickActions onAddVendor={() => {
                setSelectedVendor(null);
                setAddVendorModalOpen(true);
              }} />
              {/* <ActivityFeed activities={activities} /> */}
            </div>
          </div>
        </div>
      </main>

      <AddVendorModal
        isOpen={addVendorModalOpen}
        onClose={() => {
          setAddVendorModalOpen(false);
          setSelectedVendor(null);
        }}
        onAddVendor={handleAddVendor}
        initialData={selectedVendor} // Pass vendor for editing
      />
    </div>
  );
};

export default AdminDashboard;
